import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ContainerView from '../views/ContainerView.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'container',
    component: ContainerView
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound
  },
  // 404 页面，必须放在最后
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/platform/wxjh_website/',
  routes
})

export default router
